module.exports = __webpack_public_path__ + "static/media/Tea.78ba796c.png";